import { useToken } from '@ori/auth';
import { ApiProvider, CheckoutController, getTranslationsProps } from '@ori/checkout';
import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { ClientCultureProvider } from '@ori/culture';
import { EnvironmentProvider } from '@ori/environment';
import { FavoritesProvider } from '@ori/favorites-heart';
import { TranslationsProvider } from '@ori/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const App = ({
  currentLanguage,
  globalApiUrl,
  graphqlNetUrl,
  identityUrl,
  staticApiUrl,
  tenant,
  ...configuration
}) => {
  const translationProps = getTranslationsProps({
    currentLanguage,
    staticApiUrl,
    tenant
  });
  const {
    isUserVerified
  } = useToken();
  if (!isUserVerified) {
    return null;
  }
  return /*#__PURE__*/_jsx(ServiceUrlsProvider, {
    serviceUrls: {
      globalApiUrl,
      graphQlNetUrl: graphqlNetUrl,
      identityUrl,
      staticApiUrl
    },
    children: /*#__PURE__*/_jsx(EnvironmentProvider, {
      tenant: tenant,
      children: /*#__PURE__*/_jsx(TranslationsProvider, {
        ...translationProps,
        children: /*#__PURE__*/_jsx(ApiProvider, {
          children: /*#__PURE__*/_jsx(ClientCultureProvider, {
            language: currentLanguage,
            tenant: tenant,
            children: /*#__PURE__*/_jsx(FavoritesProvider, {
              children: /*#__PURE__*/_jsx(CheckoutController, {
                configuration: configuration
              })
            })
          })
        })
      })
    })
  });
};